import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';
import Icon from '@/components/icon/Icon.vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchInput',
  props: {
    placeholder: null,
    autofocus: { type: Boolean },
    modelValue: null,
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:modelValue', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const { t } = useI18n();



const searchKey = ref('');
const isFocus = ref(false);

const onSearch = () => {
  emits('update:modelValue', searchKey.value || '');
};
const onToggleFocus = value => {
  isFocus.value = value;
};
const onClearInput = () => {
  searchKey.value = '';
  onSearch();
  document.getElementById('searchRef')?.focus();
  onToggleFocus(true);
};

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["inline-flex input-search inputgroup align-items-center justify-content-between", [{ 'panel-focus': isFocus.value }, { 'input-disabled': __props.disabled }]])
  }, [
    _createVNode(_component_InputText, {
      placeholder: __props.placeholder ?? _unref(t)('search'),
      modelValue: searchKey.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKey).value = $event)),
      onInput: onSearch,
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (onToggleFocus(true))),
      onBlur: _cache[2] || (_cache[2] = ($event: any) => (onToggleFocus(false))),
      disabled: __props.disabled,
      class: "input-text",
      id: "searchRef"
    }, null, 8, ["placeholder", "modelValue", "disabled"]),
    (!searchKey.value)
      ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          name: "search",
          class: "opacity-50 text-gray mr-s3"
        }))
      : (_openBlock(), _createBlock(Icon, {
          key: 1,
          name: "clear",
          class: "opacity-50 text-gray mr-s3",
          onClick: onClearInput
        }))
  ], 2))
}
}

})